"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hls = _interopRequireDefault(require("hls.js"));

var _createHlsStream = _interopRequireDefault(require("@devsta/create-hls-stream"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _commonReact = require("@devsta/common-react");

var _ContextMenu = _interopRequireDefault(require("./ContextMenu"));

var _When = _interopRequireDefault(require("../../../../../../../../../common/components/When"));

var _utils = require("../../../../../../../../../common/utils");

var _utils2 = require("../../../utils");

require("../styles/_video.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getImageSrc(asset) {
  var _ref = asset || {},
      assetFiles = _ref.assetFiles;

  return assetFiles && (0, _lodash2.default)(assetFiles, 'ORIGINAL.sourceUrl');
}

function getSourceFile(asset) {
  var _ref2 = asset || {},
      assetFiles = _ref2.assetFiles;

  if (!assetFiles || !assetFiles.SD && !assetFiles.STREAM) {
    return {};
  }

  if (_hls.default.isSupported() && assetFiles.STREAM && assetFiles.STREAM.fragments.length) {
    return assetFiles.STREAM;
  }

  return assetFiles.SD || assetFiles.ORIGINAL || {};
}

function getVideoSrc(_ref3, asset) {
  var clipStartTime = _ref3.clipStartTime;

  var _ref4 = asset || {},
      assetFiles = _ref4.assetFiles;

  if (!assetFiles || !assetFiles.SD && !assetFiles.STREAM) {
    return '';
  }

  var _getSourceFile = getSourceFile(asset),
      sourceUrl = _getSourceFile.sourceUrl;

  var timeParam = clipStartTime && clipStartTime !== 0 ? "#t=".concat(clipStartTime) : '';
  return "".concat(sourceUrl).concat(timeParam);
}

var Video = /*#__PURE__*/function (_Component) {
  _inherits(Video, _Component);

  var _super = _createSuper(Video);

  function Video() {
    var _this;

    _classCallCheck(this, Video);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "setVideoRef", function (el) {
      if (!el) {
        return;
      }

      var setVideoRef = _this.props.setVideoRef;
      _this._videoRef = el;
      setVideoRef(_this._videoRef);
    });

    _defineProperty(_assertThisInitialized(_this), "attemptToCloseMenu", function () {
      var contextMenuCoords = _this.state.contextMenuCoords;

      if (!contextMenuCoords) {
        return;
      }

      _this.setState({
        contextMenuCoords: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onContextMenu", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        contextMenuCoords: {
          x: e.clientX,
          y: e.clientY
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "initStream", function () {
      var asset = _this.props.asset;
      var _this$state = _this.state,
          hlsInitialized = _this$state.hlsInitialized,
          hlsRequired = _this$state.hlsRequired;

      if (!(0, _utils2.hasTranscodedVideoFiles)(asset) || hlsInitialized || !hlsRequired) {
        return;
      }

      var _getSourceFile2 = getSourceFile(asset),
          type = _getSourceFile2.type,
          _getSourceFile2$sourc = _getSourceFile2.sourceUrl,
          sourceUrl = _getSourceFile2$sourc === void 0 ? '' : _getSourceFile2$sourc,
          fragments = _getSourceFile2.fragments;

      if (!_hls.default.isSupported() || type !== 'STREAM') {
        return void _this.setState({
          hlsRequired: false
        });
      }

      if (!_this._videoRef) {
        return;
      }

      _this.setState({
        hlsInitialized: true
      });

      var hls = (0, _createHlsStream.default)(fragments, 0, -1, sourceUrl, _this._videoRef);
      _this._hls = hls;
    });

    _defineProperty(_assertThisInitialized(_this), "handleUpdatedClip", function () {
      if (_this._hls) {
        _this._hls.destroy();
      }

      _this.setState({
        hlsInitialized: false,
        hlsRequired: true
      });

      var asset = _this.props.asset;

      var _getSourceFile3 = getSourceFile(asset),
          type = _getSourceFile3.type;

      if (type === 'STREAM') {
        _this.initStream();
      }
    });

    _this.state = {
      hlsInitialized: false,
      hlsRequired: true,
      contextMenuCoords: void 0
    };
    return _this;
  }

  _createClass(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.attemptToCloseMenu);
      window.addEventListener('contextmenu', this.attemptToCloseMenu);
      this.initStream();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref5) {
      var prevCurrentClip = _ref5.currentClip;
      var _this$props = this.props,
          asset = _this$props.asset,
          currentClip = _this$props.currentClip;
      var _this$state2 = this.state,
          hlsInitialized = _this$state2.hlsInitialized,
          hlsRequired = _this$state2.hlsRequired;

      if ((0, _utils2.hasTranscodedVideoFiles)(asset) && hlsRequired && !hlsInitialized) {
        this.initStream();
      }

      if (prevCurrentClip === currentClip) {
        return;
      }

      this.handleUpdatedClip();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _lodash.default)(nextProps, this.props) || !(0, _lodash.default)(this.state, nextState);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.attemptToCloseMenu);
      window.removeEventListener('contextmenu', this.attemptToCloseMenu);

      if (this._hls) {
        this._hls.destroy();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          currentClip = _this$props2.currentClip,
          buffering = _this$props2.buffering,
          toggleLoop = _this$props2.toggleLoop,
          loop = _this$props2.loop,
          asset = _this$props2.asset,
          children = _this$props2.children;

      if (!currentClip) {
        return (/*#__PURE__*/_react.default.createElement("div", {
            className: "video"
          }, /*#__PURE__*/_react.default.createElement("p", null, 'You haven\'t added any clips to the timeline. Drag some from the drawer to get started.'))
        );
      }

      var contextMenuCoords = this.state.contextMenuCoords;
      var isTranscoded = Boolean((0, _utils2.hasTranscodedVideoFiles)(asset));
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "video",
          onContextMenu: this.onContextMenu
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          className: "video__link-copied",
          name: "link",
          size: 50,
          color: "white"
        }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          className: "video__link-debug-copied",
          name: "success",
          size: 50,
          color: "white"
        }), /*#__PURE__*/_react.default.createElement(_When.default, {
          isTruthy: isTranscoded && buffering && !currentClip.isEmpty && !currentClip.isImage
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          className: "video__buffering",
          size: 50,
          name: "shootstagrad",
          height: 100,
          width: 100,
          color: "white"
        })), /*#__PURE__*/_react.default.createElement(_ContextMenu.default, {
          coordinates: contextMenuCoords,
          loop: loop,
          toggleLoop: toggleLoop
        }), /*#__PURE__*/_react.default.createElement(_When.default, {
          isTruthy: asset === null || (0, _utils.isAssetMissing)(asset) || !currentClip.isEmpty && !currentClip.isImage && !isTranscoded
        }, !asset || (0, _utils.isAssetMissing)(asset) ? /*#__PURE__*/_react.default.createElement(_commonReact.VideoPlaceholder, {
          icon: !asset ? 'corrupt' : 'faq',
          iconColor: "michael",
          text: !asset ? 'This clip has been removed.' : 'This clip seems to be missing.',
          subtitle: "Get in touch with the video owner if this isn't what you're expecting."
        }) : /*#__PURE__*/_react.default.createElement(_commonReact.VideoPlaceholder, null)), /*#__PURE__*/_react.default.createElement(_When.default, {
          isTruthy: currentClip.isImage && asset
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
          imageUrl: getImageSrc(asset),
          height: "calc(100% - 40px)",
          width: "calc(100% - 30px)"
        })), /*#__PURE__*/_react.default.createElement("video", {
          ref: this.setVideoRef,
          src: getVideoSrc(currentClip, asset),
          style: {
            width: isTranscoded ? '100%' : 0
          }
        }), children)
      );
    }
  }]);

  return Video;
}(_react.Component);

var _default = (0, _commonReact.withAssetSelector)(Video);

exports.default = _default;